import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TableSortModel } from 'app/shared/tablesort/tableSortModel';
import { ListLoader } from 'app/shared/components/list-loader/list-loader';
import { ComparatorService } from 'app/shared/services/comparator-service';
import { AbstractComponent } from 'app/shared/components/abstract-component/abstract.component';
import { AbstractRangregelungVm } from 'app/core/services/rangregelung-viewmodel.service';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { ErweiterungConfigResponse } from '../../../core/base-api';
import { ListLoaderWrapperComponent } from '../../components/list-loader-wrapper/list-loader-wrapper.component';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { HistoryDirective } from '../../directives/history.directive';
import { KompaktBelegComponent } from '../../kompaktdarstellung/beleg/kompakt-beleg.component';
import { KompaktStandardrechtComponent } from '../../kompaktdarstellung/standardrecht/kompakt-standardrecht.component';
import { KompaktGrundpfandrechtComponent } from '../../kompaktdarstellung/grundpfandrecht/kompakt-grundpfandrecht.component';
import { TranslatePipe } from '@ngx-translate/core';
import { KompaktGrundstueckComponent } from '../../kompaktdarstellung/grundstueck/kompakt-grundstueck.component';
import { KompaktTimepointComponent } from '../../kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { ReadMoreComponent } from '../read-more/read-more.component';
import { DatumPipe } from '../../pipes/simple/datum.pipe';
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

@Component({
  selector: 'cap-rangregelung-table',
  templateUrl: './rangregelung-table.component.html',
  imports: [
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    NgClass,
    HistoryDirective,
    KompaktBelegComponent,
    KompaktStandardrechtComponent,
    KompaktGrundpfandrechtComponent,
    TranslatePipe,
    KompaktGrundstueckComponent,
    KompaktTimepointComponent,
    ReadMoreComponent,
    DatumPipe
  ]
})
export class RangregelungTableComponent extends AbstractComponent implements OnInit, OnDestroy {
  @Input()
  hasRight = true;

  tableSortModel = new TableSortModel<AbstractRangregelungVm>('table', this.comparatorService);

  private changeDetectionTimeout: any;
  private _listLoader: ListLoader<AbstractRangregelungVm>;
  isGeschaeftsmodulCapWebErweiterung: boolean;

  constructor(
    private comparatorService: ComparatorService,
    private cdr: ChangeDetectorRef,
    private appFormatConfigService: FormatConfigService
  ) {
    super();
    keysToTranslate<string>(['DatumOderBeleg']);
    this.tableSortModel.addColumn('EnstehungSort', (a, b) => this.comparatorService.lastAbstractRangregelungVm(a, b)).switchSortDirection();
    this.addSub(
      this.appFormatConfigService.erweiterungsConfig$.subscribe((config) => {
        this.isGeschaeftsmodulCapWebErweiterung = config?.activeErweiterungen.includes(ActiveErweiterungenEnum.GESCHAEFTSMODUL_CAP_WEB);
      })
    );
  }

  ngOnInit(): void {
    this.activateChangeDetectionTrigger();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    clearTimeout(this.changeDetectionTimeout);
  }

  @Input()
  set listLoader(listLoader: ListLoader<AbstractRangregelungVm>) {
    if (!listLoader) {
      return;
    }
    this._listLoader = listLoader;
    this._listLoader.applySortModel(this.tableSortModel);
  }

  get listLoader(): ListLoader<AbstractRangregelungVm> {
    return this._listLoader;
  }

  private activateChangeDetectionTrigger() {
    this.changeDetectionTimeout = setTimeout(() => {
      this.cdr.detectChanges();
      this.activateChangeDetectionTrigger();
    }, 3000);
  }
}
